/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionGrantFragmentDoc } from "../../../../mutations/collections.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CollectionForEditDialogFragment = {
  readonly __typename: "Collection";
  readonly id: c.CollectionId;
  readonly emoji: string | null;
  readonly description: string | null;
  readonly name: string;
  readonly collectionGrants: ReadonlyArray<{
    readonly __typename: "CollectionGrant";
    readonly id: c.CollectionGrantId;
    readonly role: Types.CollectionRole;
    readonly holder:
      | {
          readonly __typename: "Group";
          readonly groupId: c.GroupId;
          readonly groupName: string;
        }
      | {
          readonly __typename: "IntrinsicGroup";
          readonly intrinsicGroupId: Types.IntrinsicGroupId;
        }
      | {
          readonly __typename: "User";
          readonly name: string | null;
          readonly email: string;
          readonly active: boolean;
          readonly imageUrl: string | null;
          readonly orgRole: Types.OrgRole;
          readonly userId: c.UserId;
        };
  }>;
};

export type UpdateCollectionMutationVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
  name: Types.Scalars["String"]["input"];
  description: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  emoji: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  memberUserIds:
    | ReadonlyArray<Types.Scalars["UserId"]["input"]>
    | Types.Scalars["UserId"]["input"];
  memberGroupIds:
    | ReadonlyArray<Types.Scalars["GroupId"]["input"]>
    | Types.Scalars["GroupId"]["input"];
  memberIntrinsicGroupIds:
    | ReadonlyArray<Types.IntrinsicGroupId>
    | Types.IntrinsicGroupId;
  managerIntrinsicGroupIds:
    | ReadonlyArray<Types.IntrinsicGroupId>
    | Types.IntrinsicGroupId;
  managerUserIds:
    | ReadonlyArray<Types.Scalars["UserId"]["input"]>
    | Types.Scalars["UserId"]["input"];
  managerGroupIds:
    | ReadonlyArray<Types.Scalars["GroupId"]["input"]>
    | Types.Scalars["GroupId"]["input"];
}>;

export type UpdateCollectionMutation = {
  readonly __typename: "Mutation";
  readonly updateCollection: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
    readonly name: string;
  };
};

export const CollectionForEditDialogFragmentDoc = /*#__PURE__*/ gql`
  fragment CollectionForEditDialogFragment on Collection {
    id
    emoji
    description
    name
    collectionGrants {
      id
      ...CollectionGrantFragment
    }
  }
  ${CollectionGrantFragmentDoc}
`;
export const UpdateCollectionDocument = /*#__PURE__*/ gql`
  mutation UpdateCollection(
    $collectionId: CollectionId!
    $name: String!
    $description: String
    $emoji: String
    $memberUserIds: [UserId!]!
    $memberGroupIds: [GroupId!]!
    $memberIntrinsicGroupIds: [IntrinsicGroupId!]!
    $managerIntrinsicGroupIds: [IntrinsicGroupId!]!
    $managerUserIds: [UserId!]!
    $managerGroupIds: [GroupId!]!
  ) {
    updateCollection(
      collectionId: $collectionId
      name: $name
      description: $description
      emoji: $emoji
      memberUserIds: $memberUserIds
      memberGroupIds: $memberGroupIds
      memberIntrinsicGroupIds: $memberIntrinsicGroupIds
      managerUserIds: $managerUserIds
      managerGroupIds: $managerGroupIds
      managerIntrinsicGroupIds: $managerIntrinsicGroupIds
    ) {
      id
      name
    }
  }
`;
export type UpdateCollectionMutationFn = Apollo.MutationFunction<
  UpdateCollectionMutation,
  UpdateCollectionMutationVariables
>;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      emoji: // value for 'emoji'
 *      memberUserIds: // value for 'memberUserIds'
 *      memberGroupIds: // value for 'memberGroupIds'
 *      memberIntrinsicGroupIds: // value for 'memberIntrinsicGroupIds'
 *      managerIntrinsicGroupIds: // value for 'managerIntrinsicGroupIds'
 *      managerUserIds: // value for 'managerUserIds'
 *      managerGroupIds: // value for 'managerGroupIds'
 *   },
 * });
 */
export function useUpdateCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCollectionMutation,
    UpdateCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCollectionMutation,
    UpdateCollectionMutationVariables
  >(UpdateCollectionDocument, options);
}
export type UpdateCollectionMutationHookResult = ReturnType<
  typeof useUpdateCollectionMutation
>;
export type UpdateCollectionMutationResult =
  Apollo.MutationResult<UpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<
  UpdateCollectionMutation,
  UpdateCollectionMutationVariables
>;
